import type { Order, OrderStatus, Product } from '@shop-monorepo/types';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { API_BASE_URL } from '@/constants/env';

export interface StatsResponse {
  orders: {
    total: number;
    byStatus: Record<OrderStatus, number>;
    revenue: number;
    revenueUnpaid: number;
  };
  clients: { total: number };
  products: { ordered: number };
  recentOrders: Order[];
  topProducts: Product[];
  monthlyRevenue: { month: number; revenue: number; count: number }[];
}

const fetchStats = async (year: number): Promise<StatsResponse> => {
  const response = await axios.get<StatsResponse>(`${API_BASE_URL}/stats`, {
    params: { year },
    withCredentials: true,
    headers: { 'X-Auth-Context': 'admin' },
  });
  return response.data;
};

export const useStats = (year: number) =>
  useQuery<StatsResponse, Error>({
    queryKey: ['stats', year],
    queryFn: () => fetchStats(year),
  });
